import axios from "axios";

export const COWORKERS_URL = "/api/coworkers/authorities";
const {REACT_APP_API_URL} = process.env;


export function getCoworkers(authority) {
    return axios.get(`${REACT_APP_API_URL}${COWORKERS_URL}/` + authority);
}
